import { Component } from '@angular/core';
/* eslint-disable @angular-eslint/component-selector */
@Component({
  standalone: true,
  selector: 'mode-empty',
  template: ``,
  styles: [],
})
export class EmptyComponent {}
